import { set } from '@/utils/vuex'

export default {
  SET_USER: set('userDetail')
}
